import Styles from "../styles/pages/ChordsEditor.module.css"
import React, {useEffect, useState} from "react";
import {isUserInRole, load_fetch} from "../pr_utils";
import {renderChordLine} from "../helpers/SongFunctions"
import SMPStyles from "../styles/components/SongManagerPanel.module.css"
import {useNavigate, useLocation} from "react-router-dom";


const ChordsEditor = ({song}) => {
    const { search } = useLocation();
    const queryParams = new URLSearchParams(search);
    const [pasteBoxContents, setPasteBoxContents] = useState('')
    const [sections, setSections] = useState([]);
    const [selectedSection, setSelectedSection] = useState(false);
    const [sectionTitle, setSectionTitle] = useState("");
    const [insertingNewSection, setInsertingNewSection] = useState(false);
    const [sectionNotes, setSectionNotes] = useState('');
    const [songId, setSongId] = useState(queryParams.get("song_id"))
    const [movingSection, setMovingSection] = useState(false);
    const [songInfo, setSongInfo] = useState(false);

    useEffect(() => {
        fetchSongSections();
        fetchSongInfo();
    }, []);
    useEffect(() => {
        setPasteBoxContents(renderSelectedSection());
        setSectionNotes(selectedSection.section_notes ?? '');
    }, [selectedSection])

    const fetchSongSections = () => {
        load_fetch(
            "handlers/Service_Handler.php",
            {operation:"FETCH_SONG_SECTIONS", songId:songId},
            (data) => {
                if(!data['ERROR'] && !data['error']) {
                    console.log(data);

                    setSections(data);
                }
            }
        )
    };
    const fetchSongInfo = () => {
        load_fetch(
            "handlers/Service_Handler.php",
            {operation:"FETCH_SONG_INFO", songId:songId},
            (data) => {
                if(!data['ERROR'] && !data['error']) {
                    console.log(data);

                    setSongInfo(data['DATA']);
                }
            }
        )
    };


    const process = () => {
        const allLines = pasteBoxContents.trimEnd().split('\n');

        let chordLines = [];
        let lyricLines = [];

        for (let i = 0; i < allLines.length; i+=2) {
            chordLines.push(parseChordLine(allLines[i]));
            lyricLines.push(allLines[i + 1]);
        }

        return {
            section_order:selectedSection?.section_order ?? -1,
            section_title:sectionTitle,
            song_id:songId,
            song_section_id:selectedSection?.song_section_id ?? -1,
            chords_data: chordLines,
            lyrics_data: lyricLines,
            section_notes: sectionNotes
        }

    }

    const renderSelectedSection = () => {
        if(!selectedSection) {
            setSectionTitle('');
            setPasteBoxContents('');
            setSectionNotes("");
            return "";
        }

        let sectionText = "";

        setSectionTitle(selectedSection.section_title);

        let chordsData = JSON.parse(selectedSection.chords_data);
        let lyricsData = JSON.parse(selectedSection.lyrics_data);

        for(let i = 0; i < lyricsData.length; i++) {

            sectionText += renderChordLine(chordsData[i]) + '\n';
            sectionText += lyricsData[i] + '\n';
        }

        return sectionText;
    }

    /**
     * Parse a chord line into [{ chord, position }, ...]
     * @param {string} line - e.g. "A             D         A"
     * @returns {Array<{chord:string, position:number}>}
     */
    function parseChordLine(line) {
        const result = [];
        const regex = /([A-G][#b]?(?:m|maj|min|dim|aug|sus|add)?\d*[A-Za-z0-9#b]*)/g;

        let match;
        while ((match = regex.exec(line)) !== null) {
            const chord = match[1];
            const position = match.index;
            result.push({ chord, position });
        }

        return result;
    }
    const cancelEditingSection = () => {
        setSelectedSection(false);
    }

    const saveEditedSection = () => {
        // Prepare Data
        let sendData = process();
        sendData.operation = "UPDATE_SONG_SECTION";

        load_fetch(
            "handlers/Service_Handler.php",
            sendData,
            (data) => {
                if(!data['ERROR'] && !data['error']) {
                    console.log(data);
                    fetchSongSections();
                    setSelectedSection(false);
                }
            })
    }
    const saveNewSection = () => {
        // Prepare Data
        let sendData = process();
        sendData.operation = "INSERT_SONG_SECTION";

        load_fetch(
            "handlers/Service_Handler.php",
            sendData,
            (data) => {
                if(!data['ERROR'] && !data['error']) {
                    console.log(data);
                    fetchSongSections();
                    setSectionTitle('');
                    setPasteBoxContents('');
                    setInsertingNewSection(false);
                    setSectionNotes('');
                }
            })
    }
    const saveSongNotes = () => {
        // Prepare Data
        let sendData = {songId:songId, notes:songInfo?.notes};
        sendData.operation = "UPDATE_SONG_NOTES";

        load_fetch(
            "handlers/Service_Handler.php",
            sendData,
            (data) => {
                if(!data['ERROR'] && !data['error']) {
                    console.log(data);
                } else {
                    console.log(data);
                }
            })
    }

    const moveSection = (section_id, direction) => {
        // If we are already moving an section, block repeat clicks before resolving first
        if(movingSection) {
            return;
        }

        // Lock movement
        setMovingSection(true);

        // Send to backend for processing
        let url = 'handlers/Service_Handler.php';

        let formData = {
            operation: 'MOVE_SONG_SECTION',
            song_id: songId,
            direction: direction,
            section_id: section_id
        }

        load_fetch(url, formData, (data) => {
            if(!data['ERROR'] && !data['error']) {
                setSections(data);
            } else {
                console.log(data);
            }
        });

        // Unlock movement
        setMovingSection(false);
    }
    const updateSongNotes = (newNotes) => {
        setSongInfo(prev => ({
            ...prev,
            notes: newNotes
        }));
    }


    return <div>
        <h1>{songInfo?.title}</h1>
        <h3>Song Notes Editor</h3>
        <div className={Styles.notesEditorHolder}>
            <textarea
                value={songInfo?.notes}
                className={Styles.notesBox}
                onChange={(event) => updateSongNotes(event.target.value)}
            ></textarea>
            <div className={Styles.notesSaveButtonHolder}>
                <button className={SMPStyles.menuButton} onClick={saveSongNotes}>Save Notes</button>
            </div>
        </div>
        <h3>Chords Editor</h3>

        {/* SECTION SELECTOR */}
        <div>
            {sections.length > 0 && !insertingNewSection && sections.map((section, index) => (
                <div key={index} className={Styles.sectionRow}>
                    <div className={Styles.reorderButtons}>
                        <button
                            onClick={() => moveSection(section.song_section_id, 'up')}
                            disabled={index === 0}
                            className={Styles.reorderButton}
                        >
                            ⬆️
                        </button>
                        <button
                            onClick={() => moveSection(section.song_section_id, 'down')}
                            disabled={index === sections.length - 1}
                            className={Styles.reorderButton}
                        >
                            ⬇️
                        </button>
                        {/*<button*/}
                        {/*    onClick={() => removeElement(el.service_element_id)}*/}
                        {/*    className={Styles.removeButton}*/}
                        {/*>*/}
                        {/*    ✖️*/}
                        {/*</button>*/}
                    </div>

                    <div
                        className={Styles.sectionSelectorButton}
                        onClick={() => {setSelectedSection(section); setInsertingNewSection(false)}}
                    >{section.section_title}</div>
                </div>

            ))}
        </div>

        {/* CONTROL BUTTONS */}
        <div className={Styles.buttonRow}>
            {selectedSection ? (
                <div>
                    <button className={SMPStyles.menuButton} onClick={saveEditedSection}>Save</button>&nbsp;
                    <button className={SMPStyles.menuButton} onClick={cancelEditingSection}>Cancel</button>
                </div>
            ) : ''}

            <button
                className={insertingNewSection || selectedSection ? Styles.hidden : SMPStyles.menuButton}
                onClick={() => setInsertingNewSection(true)}
            >
                Insert New Section</button>
            <button
                className={insertingNewSection ? SMPStyles.menuButton : Styles.hidden}
                onClick={() => setInsertingNewSection(false)}
            >
                Cancel Inserting New Section</button>
            <button
                className={insertingNewSection ? SMPStyles.menuButton : Styles.hidden}
                onClick={saveNewSection}
            >
                Save New Section</button>
        </div>

        {/* EDITING/INSERTING FORM */}
        <div>
            {selectedSection || insertingNewSection ? (
                <>
                    <input
                        type="text"
                        value={sectionTitle}
                        onChange={(event) => setSectionTitle(event.target.value)} />
                    <textarea
                        className={Styles.pasteBox}
                        value={pasteBoxContents}
                        onChange={(e) => setPasteBoxContents(e.target.value)}
                    ></textarea>
                    <textarea
                        className={Styles.sectionNotes}
                        value={sectionNotes}
                        onChange={(e) => setSectionNotes(e.target.value)}
                    ></textarea>
                </>
                ) : ''}
        </div>


    </div>
}

export default ChordsEditor;